// extracted by mini-css-extract-plugin
module.exports = {"thanks":"ThankYou_thanks__3XlRA","h4":"ThankYou_h4__3p63g","h5":"ThankYou_h5__23iFt","btn":"ThankYou_btn__1GQnb"};